import {z} from "zod/v4-mini"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {
    pointGeometryAttributeSetLikeMarker,
    curveGeometryAttributeSetLike,
    meshGeometryAttributeSetLike,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {pointGeometryAttributeLike, curveGeometryAttributeLike, meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {
    PointGeometryAttributeLikeNode,
    CurveGeometryAttributeLikeNode,
    MeshGeometryAttributeLikeNode,
} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {
    CurveGeometryAttributeSetLikeNode,
    MeshGeometryAttributeSetLikeNode,
    PointGeometryAttributeSetLikeNode,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ProjectOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/project-operator/geometry-project-operator-node"
import {
    GeometryProjectOperatorNode,
    projectOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/project-operator/geometry-project-operator-node"

export type PointGeometryProjectOperatorParameters = ProjectOperatorParameters<
    PointGeometryAttributeLikeNode,
    CurveGeometryAttributeLikeNode | MeshGeometryAttributeLikeNode,
    CurveGeometryAttributeSetLikeNode | MeshGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<PointGeometryProjectOperatorParameters> = {
    nodeClass: "PointGeometryProjectOperator",
    validation: {
        parameters: projectOperatorParametersSchema(
            pointGeometryAttributeLike,
            z.union([curveGeometryAttributeLike, meshGeometryAttributeLike]),
            z.union([curveGeometryAttributeSetLike, meshGeometryAttributeSetLike]),
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryProjectOperator
    extends GeometryProjectOperatorNode<
        0,
        PointGeometryAttributeLikeNode,
        CurveGeometryAttributeLikeNode | MeshGeometryAttributeLikeNode,
        CurveGeometryAttributeSetLikeNode | MeshGeometryAttributeSetLikeNode
    >
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
